<template>
  <!--<div class="form-indicators mb-5">
        <div class="form-indicator" :class="getPageClass(1)">
            <div class="form-indicator-number">1</div>
            <label>Alap adatok</label>
        </div>
        <div class="form-indicator-separator"></div>
        <div class="form-indicator" :class="getPageClass(2)">
            <div class="form-indicator-number">2</div>
            <label>Kiegészítők</label>
        </div>
        <div class="form-indicator-separator"></div>
        <div class="form-indicator" :class="getPageClass(3)">
            <div class="form-indicator-number">3</div>
            <label>Díjfizetés és kedvezmények</label>
        </div>
        <div class="form-indicator-separator"></div>
        <div class="form-indicator" :class="getPageClass(4)">
            <div class="form-indicator-number">4</div>
            <label>Szerződés adatok</label>
        </div>
        <div class="form-indicator-separator"></div>
        <div class="form-indicator" :class="getPageClass(5)">
            <div class="form-indicator-number">5</div>
            <label>Összesítés</label>
        </div>
    </div>-->
  <nav class="nav-pills row mb-5">
    <div class="col-md mb-2">
      <div
        class="text-center nav-link h-100 d-flex align-items-center justify-content-center"
        :class="getPageClass(1)"
      >
        1. Alap Adatok
      </div>
    </div>
    <div class="col-md mb-2">
      <div
        class="text-center nav-link h-100 d-flex align-items-center justify-content-center"
        :class="getPageClass(2)"
      >
        2. Kiegészítők
      </div>
    </div>
    <div class="col-md mb-2">
      <div
        class="text-center nav-link h-100 d-flex align-items-center justify-content-center"
        :class="getPageClass(3)"
      >
        3. Díjfizetés és kedvezmények
      </div>
    </div>
    <div class="col-md mb-2">
      <div
        class="text-center nav-link h-100 d-flex align-items-center justify-content-center"
        :class="getPageClass(4)"
      >
        4. Szerződés adatok
      </div>
    </div>
    <div class="col-md mb-2">
      <div
        class="text-center nav-link h-100 d-flex align-items-center justify-content-center"
        :class="getPageClass(5)"
      >
        5. Összesítés
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    page: {
      get() {
        return this.$store.state.page;
      },
    },
  },
  methods: {
    getPageClass(thisPage) {
      let classes = {
        active: false,
        completed: false,
        disabled: true,
      };
      if (this.page >= thisPage) classes.active = true;
      if (this.page >= thisPage + 1) classes.completed = true;
      if (this.page >= thisPage) classes.disabled = false;

      return classes;
    },
  },
};
</script>

<style lang="scss">
$red: #e4002b;
$green: #006a52;

.nav-link {
  user-select: none;
  text-transform: uppercase;

  &.active {
    border: 2px solid $green !important;
    background-color: transparent !important;
    color: $green !important;
  }

  &.completed {
    background-color: $green !important;
    color: #fff !important;
  }
}

label {
  font-size: 13px;
}

.form-indicators {
  display: flex;
  align-items: flex-start;
  user-select: none;
  overflow: auto;
}

.form-indicator {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-basis: 0;
  align-items: center;
  padding: 0 10px;
  min-width: 120px;
  text-align: center;
  color: #c2cbd2;

  &:first-child {
    padding-left: 0;
  }

  &.active {
    color: #39b54a;
  }

  &.completed > .form-indicator-number {
    background-color: #39b54a;
    color: white;
  }
}

.form-indicator-number {
  width: 30px;
  height: 30px;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 50%;
}

.form-indicator-separator {
  margin-top: 30px;
  width: 100%;
  height: 1px;
  background-color: #c2cbd2;
}
</style>
